<div class="app-icon" [style]="{'background-color': icon.colorCode}">
  <img [src]="icon.icon">
</div>